import { Component, OnInit } from '@angular/core';
import { MedicinesService } from '../services/medicines/medicines.service';
import { Medicine } from '../classes/medicine';
import { VademecumInfo } from '../classes/vademecumInfo';
import { ThrowStmt } from '@angular/compiler/src/output/output_ast';
import { Auth } from '../services/auth.service';

var Moment = require('moment');

@Component({
    selector: 'medicines',
    templateUrl: './medicines.component.html',
    styleUrls: ['./medicines.component.css']
})
export class MedicinesComponent implements OnInit {
    updateOk: boolean = false;
    updateErr;

    medicines:Array<Medicine> = [];

    vademecumInfo:VademecumInfo;
    lastUpdate:string = '';
    monthlyUpdate:boolean = false;
    hasSysOpsPermission:boolean = false;

    constructor(private medicinesService: MedicinesService,
        private auth: Auth) {}

    async ngOnInit() {
        this.hasSysOpsPermission = this.auth.hasSysOpsPermission();
        this.vademecumInfo = await this.medicinesService.info();
        this.lastUpdate = Moment(this.vademecumInfo.lastUpdate).format('LLLL');
    }

    update() {
        this.updateOk = false;
        this.updateErr = undefined;

        this.medicinesService
            .update(this.monthlyUpdate)
            .then((_) => {
                this.updateOk = true;
            })
            .catch((e) => {
                this.updateErr = e;
            });

        return false;
    }

    async search(searchText) {
        this.medicines = await this.medicinesService.find(searchText);
    }
}



// WEBPACK FOOTER //
// ./src/app/medicines/medicines.component.ts